import React from "react";
import { Family} from "../pageInside/Rolle"
import { roleDisplayLabel } from "../../utils/roleDisplayLabel";
import { tokenText } from "../pages/roleTokens/tokenText";
import "./AdminSlotTable.css";
import { elakayAutoText } from "./dataElakay";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["adminSlotTable"]?.[key] || fallback;

function computeRemainingSlots(groupedByRole, adminUserActiveRole, isFamily = false) {
    
    const referenceMax = {
        maxRoyalite: isFamily ? Infinity : (adminUserActiveRole.maxRoyalite || 0),
        maxSeller: isFamily ? Infinity : (adminUserActiveRole.maxSeller || 0),
        maxProducer: isFamily ? Infinity : (adminUserActiveRole.maxProducer || 0),
        maxAssociate: isFamily ? Infinity : (adminUserActiveRole.maxAssociate || 0),
        maxInvestment: isFamily ? Infinity : (adminUserActiveRole.maxInvestment || 0),
        maxAdmin: isFamily ? Infinity : (adminUserActiveRole.maxAdmin || 0)
      };
  

    const roleMap = {
    Royalty: "maxRoyalite",
      Seller: "maxSeller",
      Provider: "maxProducer",
      Associate: "maxAssociate",
      Investment: "maxInvestment",
      Administrator: "maxAdmin"
    };
  
    return groupedByRole?.length > 0 && groupedByRole?.map(group => {
      const roleName = group._id;
      const count = group.count || 0;
      const maxKey = roleMap[roleName] || null;
  
      if (!maxKey || referenceMax[maxKey] === undefined) return null;
  
      const maxQuantite = referenceMax[maxKey];
      const quantiteRestante = maxQuantite - count;
  
      return {
        name: roleName,
        count,
        max: maxQuantite,
        restant: quantiteRestante >= 0 ? quantiteRestante : 0
      };
    }).filter(Boolean); // Supprime les null
  }


  const AdminSlotTable = ({ objt, infoSource }) => {
__setElakayInfoSource(infoSource);
let isFamily = Family()
    let data = computeRemainingSlots(objt.groupedByRole, objt.userRole, isFamily )

    const labels = [__elakayText("t001", "User Name"), __elakayText("t005", "Quantité Ajoutée"), __elakayText("t006", "Max Quantité"), __elakayText("t007", "Quantité Restante")];
    const capacity = value => value === Infinity ? <span aria-label={elakayAutoText("h_bnd_unlimited", "Unlimited")}>∞</span> : value;
    return <section className="admin-capacity-card">
      <h2>{tokenText(infoSource)('rolePermissions')}</h2>
      <div className="admin-capacity-scroll"><table className="admin-capacity-table">
        <caption className="visually-hidden">{tokenText(infoSource)('rolePermissions')}</caption>
        <thead><tr>{labels.map(label => <th scope="col" key={label}>{label}</th>)}</tr></thead>
        <tbody>{data?.length > 0 && data.map(item => <tr key={item.name}>
          <td data-label={labels[0]}><strong>{roleDisplayLabel(item.name)}</strong></td>
          <td data-label={labels[1]}>{item.count}</td>
          <td data-label={labels[2]}>{capacity(item.max)}</td>
          <td data-label={labels[3]}><span className="admin-capacity-remaining">{capacity(item.restant)}</span></td>
        </tr>)}</tbody>
      </table></div>
    </section>;
  };

  export default AdminSlotTable;